import React from "react";
import "../scss/layout/Home.scss";

function Home({ imagePath, ...props }) {
	return (
		<main className="home">
			<img className="hero_img" src={imagePath} alt="Samolot" />
		</main>
	);
}

export default Home;
